package org.example.project.engineservice.cr

import androidx.compose.runtime.Composable

@Composable
fun CUSCRErstellung() {
    CUSCRFlow()
}
